export default __webpack_public_path__ + "static/media/Skutik-listrik-Selis-2x.d27a4638.png";